    <div class="dropdown add-to mr-2" (clickOutside)="closeDropdown()">
  <button data-testid="auto-app-add-to-campaign-button-1" class="btn-trms-light dropdown-toggle w-100" [ngClass]="{'rotate-caret':isDropdownOpen}" type="button"
    (click)="!isAddToEmailCampaignLoading && toggleDropdown()">
       <span [ngClass]="{ 'spinner-border spinner-size': isAddToEmailCampaignLoading }"
            [ngStyle]="{ 'width: 20px; height: 20px;': isAddToEmailCampaignLoading }">
            {{isAddToEmailCampaignLoading ? '' : 'Add to Campaign'}}
          </span>

  </button>

  @if(isDropdownOpen) {
    <div class="custom-dropdown-menu w-100">

      <!-- Search -->
      <div class="custom-dropdown-search">
        <i class="fa fa-search search-icon"></i>
        <input data-testid="auto-app-add-to-campaign-input-1"
          type="text"
          placeholder="Search for..."
          [formControl]="campaignSearch"
          (input)="filterCampaigns()"
          class="search-input">
      </div>

      <!-- List -->
      <ul class="custom-dropdown-list">
        @for(campaign of filteredCampaigns; track campaign.campaign_id) {
          <li
            class="custom-dropdown-item"
            [class.active]="selectedCampaign?.campaign_id === campaign.campaign_id"
            (click)="addToEmailCampaign(campaign)">
            {{ campaign.campaign_name | titlecase }}
          </li>
        }
        @if(filteredCampaigns.length === 0) {
          <li class="custom-dropdown-item no-results">No results found</li>
        }
      </ul>

      <!-- Create New -->
      <!-- <div class="custom-dropdown-footer" (click)="createNewCampaign()">
        <i class="fa fa-plus mr-2"></i>
        <span>Create New Campaign</span>
      </div> -->

    </div>
  }
</div>

<ngb-alert class="ngb-alert" *ngIf="successMessage" type="success" (close)="successMessage = ''">
  <span class="successCheck"><i class="fal fa-check"></i> </span>
  <span class="successmsg">{{ successMessage }}</span>
</ngb-alert>

<ngb-alert class="ngb-alert error-message-alert" *ngIf="errorMessage" type="danger" (close)="errorMessage = ''">
  <span class="errorCheck"><i class="fal fa-times"></i></span>
  <span class="errormsg"> {{ errorMessage }} </span>
</ngb-alert>

<ng-template #addToEmailCampaignWithViewCampaign let-modal>
  <div class=" p-2 text-white" style="background-color: #53EBA4;">
    <p class="mb-0 d-flex align-items-center"><span><i class="fa-solid fa-check mx-2 text-white f-18"></i></span>
      <span>Profile added to Campaign</span><span class="text-truncate pointer font-weight-600"
        style="text-decoration: underline;"
        (click)="redirectToEmailCampaign(selectedCampaign?.campaign_id)"><span *ngIf="campaignName">"{{campaignName}}"</span>.</span></p>
  </div>
</ng-template>
